import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import {
  SetCustomOptions,
  SetLoadCustomOptionsError,
  SetRawSchema,
  SetLoadRawSchemaError,
} from './customOptions.actions';
import { map, catchError } from 'rxjs/operators';
import { CustomOptions } from './customOptions.model';
import { of } from 'rxjs';
import { CustomOptionsService } from './customOptions.service';
import { SetActiveSchema } from '../schema/schema.actions';

@Injectable()
export class CustomOptionsEffects {
  loadCustomOptions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SetActiveSchema),
      map((action) => this.customOptionsService.extractCustomInfo(action.schema.values)),
      map((options: CustomOptions) => SetCustomOptions({ options })),
      catchError((error) => of(SetLoadCustomOptionsError({ error }))),
    ),
  );

  loadRawSchema$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SetActiveSchema),
      map((action) => action.schema.values.definitions),
      map((payload) => SetRawSchema({ payload })),
      catchError((payload) => of(SetLoadRawSchemaError({ payload }))),
    ),
  );

  constructor(private actions$: Actions, private customOptionsService: CustomOptionsService) {}
}
